//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useEffect, useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Modal } from '@material-ui/core';
import { useState } from 'react';
import { Grid } from '@material-ui/core';
// import { FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
// import { Container } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import SchoolIcon from '@material-ui/icons/School';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import MessageIcon from '@material-ui/icons/Message';
import BookmarkBorderIcon from '@material-ui/icons/BookmarkBorder';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';
// import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';
// import WebsiteIcon from '@material-ui/icons/Language';
import { useParams, useHistory } from 'react-router-dom';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
import { logPageView } from '../../system/firebase';
import { AppContext, LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import {
    PAGE_TITLE_HOME,
    PAGE_TITLE_HOME_SEO,
    PROFILE_SOCIAL_MEDIA_FACEBOOK,
    PROFILE_SOCIAL_MEDIA_INSTAGRAM,
    PROFILE_SOCIAL_MEDIA_LINKEDIN,
    // PROFILE_SOCIAL_MEDIA_TWITTER,
    // PROFILE_SOCIAL_MEDIA_WEBSITE,
    PROFILE_SOCIAL_MEDIA_YOUTUBE,
} from '../../common/constants';
import { ALICE_VIDEO_RESUME_URL, JADA_VIDEO_RESUME_URL, MICAH_VIDEO_RESUME_URL, SILAS_VIDEO_RESUME_URL } from '../../common/assetHelper';
import { getSalaryRateText } from '../../common/textHelper';
// import { AFITD_DOMAIN } from '../../system/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import LoginDialog from '../../topNav/subComponents/LoginDialog';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdPageHead from '../../common/elemental/AfitdPageHead';
import AfitdTypography from '../../common/elemental/AfitdTypography';
// import AfitdTextField from '../../common/elemental/AfitdTextField';
import AfitdButton from '../../common/elemental/AfitdButton';
import AfitdLink from '../../common/elemental/AfitdLink';
import HomeSearchInput from '../../jobCenter/subComponents/HomeSearchInput';
import VideoOverviewBlock from '../../dashboardMyProfile/subComponents/VideoOverviewBlock';
import AfitdFileTypeIcon from '../../common/elemental/AfitdFileTypeIcon';
import AfitdAvatarWithRing from '../../common/elemental/AfitdAvatarWithRing';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import Footer from './Footer';

import cardComma from '../../images/Employers/Vector.png';
import cardImg1 from '../../images/Landing/avatar6.png';
import cardImg2 from '../../images/Landing/avatar5.png';
import image1 from '../../images/Landing/image (3).jpeg';
import image2 from '../../images/Landing/image_720.png';
import googlePlayStoreImage from '../../images/Landing/google-play-badge 1.png';
import appStoreImage from '../../images/Landing/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917 1.png';
import stageImg1 from '../../images/Landing/avatar1.png';
import stageImg2 from '../../images/Landing/avatar2.png';
import stageImg3 from '../../images/Landing/avatar3.png';
import stageImg4 from '../../images/Landing/avatar4.png';
import stepImg1 from '../../images/Landing/Vector1.png';
import stepImg2 from '../../images/Landing/Vector2.png';
import stepImg3 from '../../images/Landing/Vector3.png';
import stepImg4 from '../../images/Landing/Vector 4.png';
import stepImg5 from '../../images/Landing/Vector5.png';
// import eleanorPena from '../../images/Modal/Profile/see-profile.png';
import line from '../../images/Landing/line.png';
import line1 from '../../images/Landing/line1.png';
import homeBanner1 from '../../images/Banner/Home_V1.jpg';
import homeBanner2 from '../../images/Banner/Home_V2.jpg';
import homeBanner3 from '../../images/Banner/Home_V3.jpg';
import homeBanner4 from '../../images/Banner/Home_V4.jpg';
import circle from '../../images/Banner/circle-bottom.png';

// import fbIcon from '../../images/Modal/fb-icon.png';
// import twitterIcon from '../../images/Modal/twitter-fillicon.png';
// import googleIcon from '../../images/Modal/google-icon.png';
import arrowBack from '../../images/Modal/Profile/arrow-back.png';
import arrowForward from '../../images/Modal/Profile/arrow-forward.png';

import AliceProfilePic from '../../assets/alice_profile_pic.jpg';
import AliceFacebook from '../../assets/alice_facebook.jpg';
import AliceInstagram from '../../assets/alice_instagram.jpg';
import AliceLinkedIn from '../../assets/alice_linkedin.jpg';

import SilasProfilePic from '../../assets/silas_profile_pic.jpg';
import SilasFacebook from '../../assets/silas_facebook.jpg';
import SilasInstagram from '../../assets/silas_instagram.jpg';
import SilasLinkedIn from '../../assets/silas_linkedin.jpg';

import MicahProfilePic from '../../assets/micah_profile_pic.jpg';
import MicahFacebook from '../../assets/micah_facebook.jpg';
import MicahInstagram from '../../assets/micah_instagram.jpg';
import MicahLinkedIn from '../../assets/micah_linkedin.jpg';

import JadaProfilePic from '../../assets/jada_profile_pic.jpg';
import JadaFacebook from '../../assets/jada_facebook.jpg';
import JadaInstagram from '../../assets/jada_instagram.jpg';
import JadaYouTube from '../../assets/jada_youtube.jpg';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { format as formatDate, subDays } from 'date-fns';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------

const useStyles = params => {
    const { currentBanner, mdMatches } = params;
    const socialMediaBlockUrlStyles = {
        fontFamily: 'Roboto, sans-serif',
        fontSize: '14px',
        lineHeight: '16px',
        // color: '#9B9E9C',
        // color: `${theme.palette.secondary.main}`,
        color: '#1D8A8B',
        fontWeight: '500',
        padding: '0 0 0 15px',
        // margin: '13px 0 0 0',
    };

    const socialMediaBlockUrlPlaceHolderStyles = {
        fontFamily: 'Roboto, sans-serif',
        fontSize: '14px',
        lineHeight: '16px',
        color: 'rgba(17, 30, 20, 0.4)',
        fontWeight: '500',
        padding: '5px 21px 0px 15px',
    };
    return makeStyles(theme => {
        const storeButtonStyles = { cursor: 'pointer' };
        const storeButtonImageStyles = { width: '90%' };

        return {
            '@keyframes backgroundBannerTranistion': {
                '0%': {
                    opacity: 0,
                },
                '25%': {
                    opacity: 0.3,
                },
                '50%': {
                    opacity: 0.5,
                },
                '75%': {
                    opacity: 0.8,
                },
                '100%': {
                    opacity: 1,
                },
            },
            root: { maxWidth: '100vw' },
            homeSection: { display: 'flex', flexDirection: 'column', justifyContent: 'center' },
            homeContainer: { marginBottom: '30px' },
            footerStoreButtonContainer: mdMatches ? { marginTop: '80px', maxWidth: '500px', margin: 'auto' } : { marginTop: '60px', maxWidth: '500px' },
            appStoreButton: mdMatches ? { ...storeButtonStyles, textAlign: 'center' } : storeButtonStyles,
            googlePlayStoreButton: { ...storeButtonStyles, textAlign: 'center' },
            appStoreImage: storeButtonImageStyles,
            googlePlayStoreImage: storeButtonImageStyles,

            cardContainer: {
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '100px',
                // maxWidth: '1000px',
                margin: 'auto',
                [theme.breakpoints.down('md')]: { flexDirection: 'column', width: 'auto' },
                // [theme.breakpoints.up('lg')]: { maxWidth: '1108px' },
                // [theme.breakpoints.down('lg')]: { maxWidth: '1000px' },
            },
            card: {
                width: '43%',
                height: '325px',
                backgroundColor: '#FDF1CB',
                borderRadius: '8px',
                padding: '30px',
                [theme.breakpoints.down('lg')]: { height: 380 },
                [theme.breakpoints.down('md')]: { width: 'auto', marginBottom: '16px', height: 290 },
                [theme.breakpoints.down('sm')]: { height: 460 },
                // [theme.breakpoints.up('xl')]: { width: 480 },
            },
            cardTop: { display: 'flex', justifyContent: 'space-between' },
            cardName: { display: 'flex', justifyContent: 'space-around' },
            cardTextPrimary: { fontSize: '20px', margin: 0, padding: 0, paddingLeft: '16px', fontWeight: 'bold' },
            imageContainer: { textAlign: 'center' },
            imageContainer2: { textAlign: 'center', transform: 'translate(0px, -9px)' },
            imageContainerSm: { textAlign: 'center', margin: '0px 10px' },
            imageContainerSm2: { textAlign: 'center', transform: 'translate(0px, -9px)', margin: '0px 10px' },
            paragraph: { fontSize: '20px', fontWeight: 400, lineHeight: '34px', [theme.breakpoints.down('sm')]: { fontSize: '18', textAlign: 'center' } },
            cardTextSecondary: { fontSize: '15px', margin: 0, padding: 0, paddingLeft: '16px', fontWeight: 'bold' },
            heading: {
                fontSize: '42px',
                fontWeight: 700,
                lineHeight: '52px',
                textAlign: 'center',
                padding: '16px 0',
                [theme.breakpoints.down('sm')]: { fontSize: 26, lineHeight: '34px' },
            },
            secondaryHeading: {
                fontSize: '42px',
                fontWeight: 700,
                lineHeight: '52px',
                maxWidth: '500px',
                [theme.breakpoints.down('sm')]: { fontSize: 26, lineHeight: '34px', textAlign: 'center', margin: 'auto' },
            },
            secondaryHeading2: {
                fontSize: '42px',
                fontWeight: 700,
                lineHeight: '52px',

                [theme.breakpoints.down('sm')]: { fontSize: 26, lineHeight: '34px', textAlign: 'center', margin: 'auto' },
            },
            secondaryParagraph: { fontSize: '20px', fontWeight: 400, lineHeight: '34px', margin: 'auto', textAlign: 'center' }, //maxWidth: '820px',
            button: {
                backgroundColor: '#FC821F',
                borderRadius: '4px',
                padding: '12px 37px',
                margin: 'auto',
                marginTop: '20px',
                border: 'none',
                color: 'white',
                fontSize: '20px',
                lineHeight: '40px',
                '&:hover': { cursor: 'pointer' },
            },
            bannerContainer: {
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),url('${currentBanner}')`,
                height: '710px',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                position: 'relative',
                width: '100%',
                // animation: `$backgroundBannerTranistion 1000ms ${theme.transitions.easing.easeInOut}`,
                [theme.breakpoints.down('md')]: { height: '540px' },
            },
            // bannerContent1: { margin: '0 168px' },
            bannerImageContainer: { position: 'absolute', bottom: -5, right: 44 },
            bannerHeading: {
                fontSize: 54,
                color: 'white',
                paddingTop: 65,
                // paddingBottom: 124,
                [theme.breakpoints.down('md')]: { fontSize: 38, paddingTop: 60 }, // paddingBottom: 100
                [theme.breakpoints.down('sm')]: { fontSize: 32, paddingTop: 24, textAlign: 'center' }, // paddingBottom: 130
            },
            circleImage: { [theme.breakpoints.down('md')]: { width: 200 } },
            bannerInputContainer: { backgroundColor: 'white', borderRadius: '4px' },
            bannerInput: {
                width: '100%',
                '& [type="text"]': {
                    paddingLeft: 55,
                },
            },
            bannerInputContent: {},

            inputIconsItem: {
                position: 'absolute',
                padding: '17px',
                minWidth: '40px',
                color: 'rgba(17, 30, 20, 0.4)',
            },
            inputRightButton: {
                position: 'absolute',
                right: 169,
                cursor: 'pointer',
                paddingTop: '1px',
                zIndex: 1,
            },
            buttonContainer: { display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '50px 0', marginBottom: '100px' },
            whiteParagraph: {
                fontSize: '20px',
                lineHeight: '32px',
                color: 'white',
                maxHeight: '510px',
                margin: 0,
                [theme.breakpoints.down('sm')]: { fontSize: '18px', textAlign: 'center' },
                [theme.breakpoints.down('md')]: { fontSize: '18px' },
            },
            whiteParagraphHead: {
                fontSize: '20px',
                // lineHeight: '32px',
                color: 'white',
                maxHeight: '510px',
                fontWeight: 'bold',
                [theme.breakpoints.down('md')]: { fontWeight: 'normal', fontSize: '18px' },
                [theme.breakpoints.down('sm')]: { textAlign: 'center', fontSize: '18px' },
            },
            bold: { fontWeight: 700 },
            whiteHeading: {
                fontWeight: 'bold',
                fontSize: '42px',
                lineHeight: '52px',
                textAlign: 'center',
                color: '#FFFFFF',
                maxWidth: '646px',
                margin: 'auto',
                marginBottom: '50px',
                [theme.breakpoints.down('sm')]: { fontSize: 26, lineHeight: '34px' },
                [theme.breakpoints.down('md')]: { fontSize: 36, lineHeight: '34px' },
            },
            blackContainer: {
                position: 'relative',
                backgroundColor: '#111E14',
                borderRadius: '30px',
                padding: '60px',
                marginBottom: '100px',
                marginTop: '100px',
                // maxWidth: 1108,
                marginLeft: 'auto',
                marginRight: 'auto',
                filter: 'drop-shadow(0px 30px 44px rgba(0, 0, 0, 0.2))',
                [theme.breakpoints.down('sm')]: { padding: '16px' },
                [theme.breakpoints.down('md')]: { padding: '20px' },
            },
            image: { maxWidth: '370px', width: '85%' },
            stageSection: { display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', marginTop: '100px', marginBottom: '40px' },
            stageName: { fontSize: '18px', lineHeight: '24px', marginBottom: 0, fontWeight: 'bold' },
            stageDeg: { fontSize: '16px', lineHeight: '24px', fontWeight: 400, margin: 0, color: '#868686' },
            stageButton: {
                margin: '16px 0',
                padding: '8px 12px',
                color: 'white',
                backgroundColor: '#111E14',
                fontSize: '13px',
                lineHeight: '24px',
                border: 'none',
                borderRadius: '4px',
                '&:hover': { cursor: 'pointer' },
            },
            stepsContainer: {
                display: 'flex',
                justifyContent: 'space-between',
                paddingBottom: '27px',
                marginTop: '80px',
                marginBottom: '150px',
                maxWidth: '965px',
                margin: 'auto',
                [theme.breakpoints.down('sm')]: { flexDirection: 'column', width: 'auto', marginTop: '0px', paddingTop: '80px' },
            },
            step: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                [theme.breakpoints.down('sm')]: { flexDirection: 'row', justifyContent: 'space-between' },
            },
            stepCreate: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                [theme.breakpoints.down('sm')]: { flexDirection: 'row', justifyContent: 'space-between' },
                [theme.breakpoints.down('md')]: { marginTop: 31 },
            },
            step2: { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', marginTop: '18px' },
            stepBox: {
                fontWeight: 'bold',
                padding: '13px 24px',
                border: '4px solid #F0F2F6',
                borderRadius: '100px',
                margin: '32px 0',
                zIndex: 10,
                backgroundColor: 'white',
                [theme.breakpoints.down('sm')]: { margin: '10px 0' },
                [theme.breakpoints.only('md')]: { width: 105 },
            },
            stepBox5: {
                fontWeight: 'bold',
                padding: '13px 24px',
                border: '4px solid #F0F2F6',
                borderRadius: '100px',
                margin: '32px 0',
                marginTop: 35,
                zIndex: 10,
                backgroundColor: 'white',
                [theme.breakpoints.down('sm')]: { margin: '10px 0' },
            },
            stepName: { fontWeight: 'bold', fontSize: '18px', textAlign: 'center' },
            stepNameSm: { fontWeight: 'bold', fontSize: '18px', textAlign: 'start', width: 202, maxWidth: 150 },
            stepNameCreateAcc: { fontWeight: 'bold', fontSize: '18px', textAlign: 'center' },
            stepNameUpload: { fontWeight: 'bold', fontSize: '18px', textAlign: 'center', marginBottom: '-54px', [theme.breakpoints.down('md')]: { marginBottom: '-88px' } },
            stepNameInterview: { fontWeight: 'bold', fontSize: '18px', textAlign: 'center', marginBottom: '-77px' },
            stepNameHiring: { fontWeight: 'bold', fontSize: '18px', textAlign: 'center', marginBottom: '-30px', [theme.breakpoints.down('md')]: { marginBottom: '-108px' } },
            stepNameAttach: { fontWeight: 'bold', fontSize: '18px', textAlign: 'center', marginBottom: '-58px', [theme.breakpoints.down('md')]: { marginBottom: '-88px' } },
            howItWorks: {
                backgroundImage: 'url(' + line + ')',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                [theme.breakpoints.only('md')]: { backgroundSize: 'contain' },
                [theme.breakpoints.down('sm')]: { backgroundImage: 'url(' + line1 + ')', backgroundPositionX: '57px', padding: '0 20px' },
            },
            paper: {
                position: 'absolute',
                width: 400,
                backgroundColor: theme.palette.background.paper,
                border: '2px solid #000',
                boxShadow: theme.shadows[5],
                padding: theme.spacing(2, 4, 3),
            },
            modalContainer: { overflowY: 'hidden' },
            modalContent: { background: 'white', width: '554px', marginTop: 110, borderRadius: '10px', [theme.breakpoints.down('sm')]: { width: '332px' } },
            logInHeading: { fontSize: 26, fontWeight: 'bold', textAlign: 'center' },
            logInPara: { marginTop: '16px', marginBottom: '32px', textAlign: 'center' },

            continueFbContainer: {
                background: 'rgba(57, 117, 234, 1)',
                width: '474px',
                borderRadius: '4px',
                marginTop: '16px',
                marginBottom: '16px',
                [theme.breakpoints.down('sm')]: { width: '316px' },
            },
            continueFbBtn: {
                width: '474px',
                [theme.breakpoints.down('sm')]: { width: '316px' },
                '&:hover': {
                    background: 'rgba(57, 117, 234, 1)',
                },
                paddingTop: '15px',
                paddingBottom: '15px',
            },
            ContinueText: { fontSize: 16, fontWeight: 700, color: 'white' },
            iconPosition: { position: 'absolute', left: 16 },

            continueTwitterContainer: {
                background: 'rgba(29, 161, 242, 1)',
                width: '474px',
                borderRadius: '4px',
                marginTop: '16px',
                marginBottom: '16px',
                [theme.breakpoints.down('sm')]: { width: '316px' },
            },
            continueTwitterBtn: {
                width: '474px',
                [theme.breakpoints.down('sm')]: { width: '316px' },
                '&:hover': {
                    background: 'rgba(29, 161, 242, 1)',
                },
                paddingTop: '15px',
                paddingBottom: '15px',
            },

            continueGoogleContainer: {
                background: '#FFFFFF',
                width: '474px',
                borderRadius: '4px',
                marginTop: '16px',
                marginBottom: '16px',
                border: '1px solid #D5D7DD',
                [theme.breakpoints.down('sm')]: { width: '316px' },
            },
            continueGoogleBtn: {
                width: '474px',
                [theme.breakpoints.down('sm')]: { width: '316px' },
                '&:hover': {
                    background: '#FFFFFF',
                },
                paddingTop: '15px',
                paddingBottom: '15px',
            },
            ContinueGoogleText: { fontSize: 16, fontWeight: 700, color: 'rgba(0, 0, 0, 0.54)' },

            createWithEmailText: { fontSize: 16, fontWeight: 400, color: '#9B9E9C', marginTop: 8, marginBottom: 24, textAlign: 'center' },

            contactsUsContainer: { textAlign: 'center' },
            radioContainer: { marginLeft: '25px' },
            inputWidth: { maxWidth: '100%', marginTop: '10px', marginBottom: '30px' },
            submitButtonContainer: { marginTop: 38 },
            submitButton: { textTransform: 'capitalize', width: '100%', padding: 17, fontSize: 18, fontWeight: 500 },
            inputPaddingLeft: { paddingLeft: '10px', [theme.breakpoints.down('sm')]: { paddingLeft: 0 } },
            inputPaddingRight: { paddingRight: '10px', [theme.breakpoints.down('sm')]: { paddingRight: 0 } },
            modalStyle1: {
                position: 'absolute',
                top: '10%',
                left: '10%',
                overflow: 'scroll',
                height: '100%',
                display: 'block',
            },
            seeProfileModalStyle: {
                // [theme.breakpoints.down('md')]: { position: 'absolute', top: '10%', left: '10%', overflow: 'scroll', height: '100%', display: 'block' },
            },

            formContainer: { width: '474px', [theme.breakpoints.down('sm')]: { width: '316px' } },
            alreadyAcContainer: { marginTop: 17, marginBottom: 17, textAlign: 'center' },
            alreadyAcText: { fontSize: 16, fontWeight: 500, textDecoration: 'underline' },
            privacyPolicyText: { fontSize: 14, fontWeight: 400 },
            privacyPolicyLink: { fontSize: 14, fontWeight: 400, textDecoration: 'underline' },
            privacyPolicyContainer: { paddingTop: 16, paddingBottom: 40, textAlign: 'center' },
            createAccountLink: { fontSize: 14, fontWeight: 400, textDecoration: 'underline' },
            termsConditionLink: { fontSize: 14, fontWeight: 400, textDecoration: 'underline' },
            checkBoxContainer: { marginLeft: -23 },
            closeIconContainer: { textAlign: 'right', marginTop: 29, marginRight: 29, marginBottom: 9, color: 'rgba(17, 30, 20, 0.4)' },
            createWithEmailItem13: {
                marginBottom: 12,
                paddingRight: 40,
                paddingLeft: 40,
                color: 'rgba(240, 242, 246, 1)',
                [theme.breakpoints.down('sm')]: { maxWidth: '10%', paddingRight: 0, paddingLeft: 0 },
            },
            profileModalContent: {
                background: 'white',
                width: '872px',
                marginTop: 'calc((100vh - 95vh)/2)',
                paddingBottom: 20,
                maxHeight: '95vh',
                borderRadius: '10px',
                [theme.breakpoints.down('lg')]: { width: '825px' },
                [theme.breakpoints.down('md')]: { width: '710px', marginBottom: 30 },
                [theme.breakpoints.down('sm')]: { width: '95%' },
            },
            closeIconContent: { cursor: 'pointer' },
            profileContainer: { paddingLeft: 40, paddingRight: 40, [theme.breakpoints.down('md')]: { paddingLeft: 10, paddingRight: 10 } },
            profileName: { fontSize: 20, fontWeight: 'bold', color: ' #111E14;' },
            profileLocation: { fontSize: 20, color: 'rgba(17, 30, 20, 1)', [theme.breakpoints.down('md')]: { fontSize: 16 } },
            // profileAboutMe: { marginBottom: 18 },
            profileOccupation: { marginTop: 39, marginBottom: 14 },
            profileDetails: { fontSize: 15, fontWeight: 400, color: 'rgba(17, 30, 20, 1)' },
            occupationBtn: { color: 'rgba(255, 255, 255, 1)', backgroundColor: '#1D8A8B', padding: '9px 10px', borderRadius: '4px', fontSize: '14px' },
            occupationItem: { marginRight: 8 },
            skillBtn: { color: 'rgba(17, 30, 20, 1)', backgroundColor: 'rgba(240, 242, 246, 1)', padding: '9px 10px', borderRadius: '4px', fontSize: '14px' },
            closeIconContainerProfile: { textAlign: 'right', marginTop: 29, marginRight: 29, color: 'rgba(17, 30, 20, 0.4)' },

            btnLeftIcon: { marginRight: '8px', [theme.breakpoints.down('md')]: { paddingLeft: '0px' } },
            profileBtn: { fontWeight: 'bold', [theme.breakpoints.down('sm')]: { width: '100%' } },
            lastBtnLeftIcon: { marginRight: '8px', [theme.breakpoints.down('md')]: { marginRight: 0 }, [theme.breakpoints.down('sm')]: { marginRight: 8 } },
            profileLastBtn: {
                fontWeight: 'bold',
                paddingRight: 15,
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                color: 'rgba(17, 30, 20, 1)',
                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)', color: 'rgba(17, 30, 20, 1)' },
                [theme.breakpoints.down('md')]: { paddingRight: 12 },
                [theme.breakpoints.down('sm')]: { width: '100%' },
            },
            lastButtonDiv: { textAlign: 'right', [theme.breakpoints.down('md')]: { textAlign: 'left' } },
            // profileQualification: { marginRight: 18, [theme.breakpoints.down('sm')]: { marginRight: '-7px' } },
            // profileQualificationHeading: { color: 'rgba(17, 30, 20, 1)', fontWeight: 500, fontSize: 14, [theme.breakpoints.down('sm')]: { fontWeight: 600 } },
            // profileQualificationIcon: { width: 16, color: 'rgba(155, 158, 156, 1)', marginTop: 5, marginRight: 12, [theme.breakpoints.down('sm')]: { marginRight: 5 } },
            profileBtnContainer: { paddingBottom: 14, [theme.breakpoints.down('sm')]: { justifyContent: 'center' } },

            blackContainerCircle: {
                position: 'absolute',
                bottom: -5,
                right: '124px',
                [theme.breakpoints.down('lg')]: { right: '83px' },
                [theme.breakpoints.down('md')]: { right: '47px' },
                [theme.breakpoints.down('sm')]: { right: '34px' },
            },
            blackContainerCircleImg: { [theme.breakpoints.down('md')]: { width: 160, height: 80 } },
            circleImageBottomPadding: { paddingBottom: 100, [theme.breakpoints.down('md')]: { paddingBottom: 60 }, [theme.breakpoints.down('sm')]: { paddingBottom: 55 } },
            arrowBack: {
                paddingRight: 16,
                cursor: 'pointer',
                paddingTop: 80,
                [theme.breakpoints.down('md')]: { paddingRight: 0, marginRight: -25, zIndex: 1 },
            },
            arrowBackImg: {
                [theme.breakpoints.down('md')]: { width: 40, height: 40 },
                [theme.breakpoints.down('sm')]: { position: 'absolute', top: 100, left: 55, width: 40, height: 40 },
            },
            arrowForward: {
                paddingLeft: 16,
                cursor: 'pointer',
                paddingTop: 80,
                [theme.breakpoints.down('md')]: { paddingLeft: 0, marginLeft: -25, zIndex: 1 },
            },
            arrowForwardImg: {
                [theme.breakpoints.down('md')]: { width: 40, height: 40 },
                [theme.breakpoints.down('sm')]: { position: 'absolute', top: 100, right: 55, width: 40, height: 40 },
            },
            fieldLevel: { fontWeight: 'bold' },
            profileBtnAndAboutContainer: {
                [theme.breakpoints.down('sm')]: {
                    paddingTop: 10,
                    height: 395,
                    overflowY: 'scroll',
                    overflowX: 'hidden',
                    '&::-webkit-scrollbar-track': {
                        borderRadius: '10px',
                        background: 'none',
                    },
                    '&::-webkit-scrollbar': {
                        width: '8px',
                        backgroundColor: '#F5F5F5',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        borderRadius: '10px',
                        backgroundColor: 'rgba(0,0,0,0.2)',
                    },
                },
            },
            profileAboutMeSection: {
                marginTop: 10,
                paddingBottom: 100,
                [theme.breakpoints.up('md')]: {
                    height: 400,
                    overflowY: 'scroll',
                    overflowX: 'hidden',
                    '&::-webkit-scrollbar-track': {
                        borderRadius: '10px',
                        background: 'none',
                    },
                    '&::-webkit-scrollbar': {
                        width: '8px',
                        backgroundColor: '#F5F5F5',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        borderRadius: '10px',
                        backgroundColor: 'rgba(0,0,0,0.2)',
                    },
                },
            },
            mainContainer: {
                padding: '0 60px',
                [theme.breakpoints.down('sm')]: { padding: '0 10px' },
                [theme.breakpoints.up('xl')]: { padding: '0 120px' },
                [theme.breakpoints.only('lg')]: { padding: '0 44px' },
            },
            img: { width: '100%' },
            profileTwoButton: { direction: 'row', [theme.breakpoints.down('md')]: { justifyContent: 'center', alignItems: 'center', textAlign: 'center' } },
            profileContent2Div: { [theme.breakpoints.down('sm')]: { textAlign: 'center' } },
            profileContent1: { [theme.breakpoints.down('sm')]: { textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            profileButtons01: { [theme.breakpoints.down('sm')]: { marginTop: '-8px' } },
            profileButtons02: { [theme.breakpoints.down('sm')]: { paddingTop: 16 } },
            profileBtnContent2: { [theme.breakpoints.down('sm')]: { paddingTop: 16 } },
            bannerParagraph: {
                fontSize: 20,
                color: 'rgba(255, 255, 255, 0.8)',
                paddingBottom: 40,
            },
            resumeCardParagraph: { fontSize: 18 },

            //---------------------------------------------------------------------
            // pre-demo updates
            //---------------------------------------------------------------------
            profileQualificationContent: { marginTop: 5, marginBottom: 10, [theme.breakpoints.down('sm')]: { justifyContent: 'center' } },
            profileQualificationContainer: {
                flexDirection: 'row',
                display: 'flex',
                alignItems: 'center',
                marginRight: 20,
            },
            profileQualificationIcon: { color: '#9B9E9C', fontSize: 16, marginRight: 8, [theme.breakpoints.down('sm')]: { marginRight: 5 } },
            profileQualificationHeading: { fontWeight: 'bold' },
            profileDetailHeading: { fontWeight: 'bold', marginTop: 10 },
            profileDetailContainer: { marginBottom: 20 },

            resumeContainer: {
                padding: 20,
                border: '1px solid #D5D7DD',
                borderRadius: 4,
                marginTop: 10,
                background: 'rgba(255,255,255,0.9)',
            },
            inline: { display: 'flex', alignItems: 'center' },
            fileTextContainer: { marginLeft: 20 },

            socialMediaBlock: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                borderRadius: '4px',
                margin: '13px 0 0 0',
                padding: '0 0 10px 0',
                border: '1px solid #D5D7DD',
            },
            socialIcons: {
                // fontSize: '46px',
                // padding: '12px',
                // paddingBottom: '0px',
                // [theme.breakpoints.down('md')]: { padding: '3px', marginTop: 7 },
                fontSize: '46px',
                padding: '0px',
                paddingTop: 8,
                margin: '0px 8px',
            },
            socialMediaBlockTitle: {
                fontFamily: 'Roboto, sans-serif',
                fontSize: '16px',
                lineHeight: '19px',
                color: '#111E14',
                fontWeight: '600',
                padding: '15px 21px 0px 15px',
            },
            socialMediaBlockUrl: {
                ...socialMediaBlockUrlStyles,
            },
            socialMediaBlockUrlPlaceHolder: {
                ...socialMediaBlockUrlPlaceHolderStyles,
            },

            exampleProfilesDisclaimerText: { textAlign: 'center' },
        };
    });
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        setIsLogin,
        loginModalOpen,
        isLoginMode,
        handleCloseLoginModal,
        hideThumbnail,
        setHideThumbnail,
        handleClickAppStoreButton,
        handleClickGooglePlayStoreButton,
    } = params;

    const defns = {
        bannerContainer: { container: true, justify: 'center' },
        bannerContent1: { item: true, xl: 10, lg: 11, md: 10, sm: 11, xs: 11 },
        mainContainer: { container: true, xl: 10, lg: 11, md: 10, sm: 11, xs: 11 },
        homeContainer: { container: true, justify: 'center' },
        footerStoreButtonContainer: { container: true, justify: 'center' },
        appStoreButton: { item: true, lg: 6, md: 6, sm: 6, xs: 6, onClick: handleClickAppStoreButton },
        googlePlayStoreButton: { item: true, lg: 6, md: 6, sm: 6, xs: 6, onClick: handleClickGooglePlayStoreButton },
        homeSection: { item: true, lg: 6, md: 6, sm: 12, xs: 12 },
        homeSection2: { item: true, lg: 6, md: 12, sm: 12, xs: 12 },
        bannerHeading: {},
        bannerImageContainer: {},
        circleImage: {},
        bannerInputContainer: { container: true, direction: 'row', justify: 'center' },
        bannerInputContent: { item: true, lg: 6, md: 6, sm: 6, xs: 6 },
        bannerInput: {},

        inputIconsItem: {},
        inputRightButton: {},
        stageSection: { item: true, lg: 3, md: 3, sm: 6, xs: 6 },
        stageContainer: { container: true },
        stageButton: { type: 'button' },
        button: { type: 'button' },
        modalContainer: { container: true, direction: 'row', justify: 'center', alignItems: 'center' },
        modalContent: { item: true },
        continueFb: { container: true, direction: 'row', justify: 'center' },
        continueFbContent: { item: true },

        contactsFormSection: { container: true, direction: 'row', justify: 'center' },
        contactsFormGrid: { item: true },
        formInputContainer: { container: true },
        formInputItem: { item: true, lg: 6, md: 6, sm: 12, xs: 12 },
        formMainGrid: { container: true, direction: 'row', justify: 'center' },
        formMainGridItem: { item: true },
        createWithEmailContainer: { container: true, direction: 'row', justify: 'center', alignItems: 'center' },
        createWithEmailItem2: { item: true, lg: 6, md: 6, sm: 8, xs: 8 },
        createWithEmailItem13: { item: true, lg: 3, md: 3, sm: 4, xs: 4 },
        exampleProfilesDisclaimerText: { variant: 'body2' },
        profileContainer: { container: true, direction: 'row', justify: 'center' },
        profileContent1: { item: true, lg: 2, md: 2, sm: 12, xs: 12 },
        profileContent2: { item: true, lg: 10, md: 10, sm: 12, xs: 12 },
        occupationContainer: { container: true, direction: 'row' },
        occupationItem: { item: true },
        profileBtnContainer: { container: true, direction: 'row' },
        profileBtnContent1: { item: true, lg: 8, md: 8, sm: 12, xs: 12 },
        profileBtnContent2: { item: true, lg: 4, md: 4, sm: 12, xs: 12 },
        // profileQualificationContent: { container: true, direction: 'row' },
        // profileQualification: { item: true },

        // profileQualificationIconContainer: { container: true, direction: 'row', alignItems: 'center' },
        // profileQualificationIconContent: { item: true },

        profileQualificationContent: { container: true, direction: 'row' },
        profileQualificationHeading: { variant: 'body2' },
        profileDetailHeading: { variant: 'body1' },

        profileTwoButton: { container: true },
        profileButtons01: { item: true, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 },
        profileButtons02: { item: true, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 },

        videoOverviewBlock: {
            vjsPlayerStyles: { maxWidth: 600, maxHeight: 400 },
            onPlayVideo: () => setHideThumbnail(true),
            hideThumbnail,
        },
        resumeTitleText: { variant: 'body2' },
        resumeDateText: { variant: 'body2' },

        alreadyAcText: {
            color: 'secondary',
            onClick: () => {
                setIsLogin(true);
            },
        },
        createAccountLink: {
            color: 'secondary',
            onClick: () => {
                setIsLogin(false);
            },
        },
        termsConditionLink: {
            color: 'secondary',
            // onClick: () => {
            //     setIsLogin(false);
            // },
        },
        privacyPolicyLink: {
            color: 'secondary',
            // onClick: () => {
            //     setIsLogin(false);
            // },
        },
        loginDialog: {
            open: loginModalOpen,
            isLoginMode,
            noLogin: true,
            onClose: handleCloseLoginModal,
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const UrlLink = props => {
    if (_isEmpty(props.label)) {
        return <AfitdTypography {...props} />;
    } else {
        return <AfitdLink {...props} rel="noopener noreferrer" />;
    }
};

// const handleClickUrlLink = (url, evt) => {
//     if (!_isEmpty(url)) {
//         window.open(url, '_blank');
//     }
// };

let socialWindow = null;
const backgroundImages = [homeBanner1, homeBanner2, homeBanner3, homeBanner4];

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const Landing = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const theme = useTheme();
    const smMatches = useMediaQuery(theme.breakpoints.down('sm'));
    const mdMatches = useMediaQuery(theme.breakpoints.down('md'));
    const lgMatchesUp = useMediaQuery(theme.breakpoints.up('lg'));
    const history = useHistory();
    let { profileId } = useParams();
    profileId = profileId === '1' ? 1 : null;

    const appContext = useContext(AppContext);
    const { sys } = appContext;
    const appStoreUrl = sys?.appStoreUrl;
    const googlePlayStoreUrl = sys?.googlePlayStoreUrl;

    const layoutContext = useContext(LayoutContext);
    const { scrollToPageTop } = layoutContext;
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // radio group MIU
    // const [value, setValue] = useState('Job Seeker');

    // const [isBlack, setIsBlack] = useState(true);
    const [currentBanner] = useState(backgroundImages[Math.floor(Math.random() * 4)]);

    // login or register modal
    const [loginModalOpen, setLoginModalOpen] = useState(false);

    const [isLoginMode, setIsLoginMode] = useState(false);

    // for see profile modal
    // const [profileModalOpen, setProfileModalOpen] = useState([false, false, false, false]);
    const [currentProfileIdx, setCurrentProfileIdx] = useState(profileId);

    const [hideThumbnail, setHideThumbnail] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        logPageView(PAGE_TITLE_HOME);
    }, []);

    // on mount, scroll to the top of the page
    useEffect(() => {
        scrollToPageTop();
    }, [scrollToPageTop]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    // const handleChange = event => {
    //     setValue(event.target.value);
    // };

    const handleOpenLoginModal = () => {
        setLoginModalOpen(true);
    };

    const handleCloseLoginModal = () => {
        setLoginModalOpen(false);
    };

    const handleOpenProfile = idx => {
        setCurrentProfileIdx(idx);
    };

    const handleCloseProfile = () => {
        setCurrentProfileIdx(null);
        setHideThumbnail(false);
        history.push(`/home`);
    };

    const handleClickPreviousProfileButton = idx => {
        setCurrentProfileIdx(idx);
    };

    const handleClickAppStoreButton = () => {
        window.open(appStoreUrl, '_blank', 'noopener,noreferrer');
    };

    const handleClickGooglePlayStoreButton = () => {
        window.open(googlePlayStoreUrl, '_blank', 'noopener,noreferrer');
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const classes = useStyles({ currentBanner, mdMatches })();

    const defns = getDefns({
        classes,
        props,
        isLoginMode,
        setIsLoginMode,
        currentBanner,
        handleOpenLoginModal,
        loginModalOpen,
        handleCloseLoginModal,
        hideThumbnail,
        setHideThumbnail,
        handleClickAppStoreButton,
        handleClickGooglePlayStoreButton,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <AfitdPageHead
                title={PAGE_TITLE_HOME_SEO}
                noSiteNameInTitle
                description="We are the ultimate job-seeking platform for job seekers to find career opportunities. We offer job solutions including entry-level marketing jobs, career searches and more!"
                keywords="job-seeking platform, find your dream job, platform jobseeker, job seekers, seeking for a job, find career opportunities, job solutions, career search, entry level marketing jobs"
                // canonicalUrl={`https://${AFITD_DOMAIN}/`}
            />
            {/* banner section start */}
            <Grid {...defns.bannerContainer}>
                <Grid {...defns.bannerContent1}>
                    <h1 {...defns.bannerHeading}>
                        Show The World What You’ve Got.
                        <br />
                        Find Jobs That Fit Your Story.
                    </h1>
                    <p {...defns.bannerParagraph}>
                        <span style={{ fontWeight: 'bold' }}> A Foot in the Door</span> is a next-generation job search platform dedicated exclusively to job{' '}
                        {lgMatchesUp && <br />}
                        seekers with <span style={{ color: theme.palette.primary.main, fontWeight: 'bold' }}>0-5 years of work experience</span>.
                    </p>
                    <HomeSearchInput />
                </Grid>

                {smMatches ? null : (
                    <Grid {...defns.bannerImageContainer}>
                        <img {...defns.circleImage} src={circle} alt="" />
                    </Grid>
                )}
            </Grid>

            <div {...defns.mainContainer}>
                <h1 {...defns.heading}>How It Works</h1>
                {smMatches ? (
                    <div {...defns.howItWorks}>
                        <div {...defns.stepsContainer}>
                            <div {...defns.step}>
                                <div {...defns.stepBox} style={{ whiteSpace: 'nowrap' }}>
                                    STEP 1
                                </div>
                                <div {...defns.imageContainerSm} style={{ marginTop: 10 }}>
                                    <img src={stepImg1} alt="" />
                                </div>
                                <div {...defns.stepNameSm} style={{ fontSize: 15 }}>
                                    Create an account
                                </div>
                            </div>
                            <div {...defns.step}>
                                <div {...defns.stepBox} style={{ whiteSpace: 'nowrap' }}>
                                    STEP 2
                                </div>
                                <div {...defns.imageContainerSm2} style={{ marginTop: 22 }}>
                                    <img src={stepImg2} alt="" />
                                </div>
                                <div {...defns.stepNameSm} style={{ marginBottom: 10, fontSize: 15 }}>
                                    Upload a 60 second <br />
                                    profile video sharing <br />
                                    your story
                                </div>
                            </div>
                            <div {...defns.step}>
                                <div {...defns.stepBox} style={{ whiteSpace: 'nowrap' }}>
                                    STEP 3
                                </div>
                                <div {...defns.imageContainerSm} style={{ marginTop: 10 }}>
                                    <img src={stepImg3} alt="" />
                                </div>
                                <div {...defns.stepNameSm} style={{ marginTop: 10, marginBottom: 10, fontSize: 15 }}>
                                    Attach a resume and <br />
                                    other info to your
                                    <br />
                                    profile
                                </div>
                            </div>
                            <div {...defns.step}>
                                <div {...defns.stepBox} style={{ whiteSpace: 'nowrap' }}>
                                    STEP 4
                                </div>
                                <div {...defns.imageContainerSm} style={{ marginTop: 8 }}>
                                    <img src={stepImg4} alt="" />
                                </div>
                                <div {...defns.stepNameSm} style={{ marginTop: 10, marginBottom: 10, fontSize: 15 }}>
                                    A hiring manager <br />
                                    sees your profile and video
                                </div>
                            </div>
                            <div {...defns.step}>
                                <div {...defns.stepBox} style={{ backgroundColor: '#FC821F', color: '#FFFFFF', whiteSpace: 'nowrap' }}>
                                    STEP 5
                                </div>
                                <div {...defns.imageContainerSm} style={{ marginBottom: 10 }}>
                                    <img src={stepImg5} alt="" />
                                </div>
                                <div {...defns.stepNameSm} style={{ marginTop: 10, fontSize: 15 }}>
                                    Let’s say someone <br />
                                    wants to interview <br />
                                    you, we email you with details!
                                </div>
                            </div>
                        </div>
                    </div>
                ) : mdMatches ? (
                    <div {...defns.howItWorks}>
                        <div {...defns.stepsContainer}>
                            <div {...defns.stepCreate}>
                                <div {...defns.imageContainer}>
                                    <img src={stepImg1} alt="" />
                                </div>
                                <div {...defns.stepBox}>STEP 1</div>
                                <div {...defns.stepNameCreateAcc}>
                                    Create an
                                    <br />
                                    account
                                </div>
                            </div>
                            <div {...defns.step2}>
                                <div {...defns.imageContainer2}>
                                    <img src={stepImg2} alt="" />
                                </div>
                                <div {...defns.stepBox}>STEP 2</div>
                                <div {...defns.stepNameUpload}>
                                    Upload a 60
                                    <br />
                                    second profile
                                    <br />
                                    video sharing
                                    <br />
                                    your story
                                </div>
                            </div>
                            <div {...defns.step}>
                                <div {...defns.imageContainer}>
                                    <img src={stepImg3} alt="" />
                                </div>
                                <div {...defns.stepBox}>STEP 3</div>
                                <div {...defns.stepNameAttach}>
                                    Attach a
                                    <br />
                                    resume and
                                    <br />
                                    other info to
                                    <br />
                                    your profile
                                </div>
                            </div>
                            <div {...defns.step}>
                                <div {...defns.imageContainer}>
                                    <img src={stepImg4} alt="" />
                                </div>
                                <div {...defns.stepBox}>STEP 4</div>
                                <div {...defns.stepNameHiring}>
                                    A hiring <br /> manager <br />
                                    sees your
                                    <br /> profile and
                                    <br /> video
                                </div>
                            </div>
                            <div {...defns.step}>
                                <div {...defns.imageContainer}>
                                    <img src={stepImg5} alt="" />
                                </div>
                                <div {...defns.stepBox5} style={{ backgroundColor: '#FC821F', color: '#FFFFFF' }}>
                                    STEP 5
                                </div>
                                <div {...defns.stepNameInterview}>
                                    Let’s say someone <br /> wants to interview <br />
                                    you, we email you
                                    <br /> with details!
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div {...defns.howItWorks}>
                        <div {...defns.stepsContainer}>
                            <div {...defns.stepCreate}>
                                <div {...defns.imageContainer}>
                                    <img src={stepImg1} alt="" />
                                </div>
                                <div {...defns.stepBox}>STEP 1</div>
                                <div {...defns.stepNameCreateAcc}>Create an account</div>
                            </div>
                            <div {...defns.step2}>
                                <div {...defns.imageContainer2}>
                                    <img src={stepImg2} alt="" />
                                </div>
                                <div {...defns.stepBox}>STEP 2</div>
                                <div {...defns.stepNameUpload}>
                                    Upload a 60 second <br />
                                    profile video sharing <br />
                                    your story
                                </div>
                            </div>
                            <div {...defns.step}>
                                <div {...defns.imageContainer}>
                                    <img src={stepImg3} alt="" />
                                </div>
                                <div {...defns.stepBox}>STEP 3</div>
                                <div {...defns.stepNameAttach}>
                                    Attach a resume and <br />
                                    other info to your
                                    <br />
                                    profile
                                </div>
                            </div>
                            <div {...defns.step}>
                                <div {...defns.imageContainer}>
                                    <img src={stepImg4} alt="" />
                                </div>
                                <div {...defns.stepBox}>STEP 4</div>
                                <div {...defns.stepNameHiring}>
                                    A hiring manager sees <br />
                                    your profile and video
                                </div>
                            </div>
                            <div {...defns.step}>
                                <div {...defns.imageContainer}>
                                    <img src={stepImg5} alt="" />
                                </div>
                                <div {...defns.stepBox5} style={{ backgroundColor: '#FC821F', color: '#FFFFFF' }}>
                                    STEP 5
                                </div>
                                <div {...defns.stepNameInterview}>
                                    Let’s say someone <br />
                                    wants to interview you, <br />
                                    we will send you <br />
                                    the details!
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {/* see profile section */}
                <div {...defns.stageContainer}>
                    {/* profile modal start */}
                    <div>
                        {/* ============================================================== */}
                        {/* == Profile 1                                                   */}
                        {/* ============================================================== */}
                        <Modal
                            open={currentProfileIdx === 1}
                            onClose={handleCloseProfile}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            {...defns.seeProfileModalStyle}
                        >
                            <Grid {...defns.modalContainer}>
                                <Grid {...defns.arrowBack}>
                                    <img {...defns.arrowBackImg} src={arrowBack} alt="" onClick={handleClickPreviousProfileButton.bind(null, 4)} />
                                </Grid>

                                <Grid {...defns.profileModalContent}>
                                    <div {...defns.closeIconContainerProfile}>
                                        <CloseIcon {...defns.closeIconContent} onClick={handleCloseProfile} />
                                    </div>

                                    <Grid {...defns.profileContainer}>
                                        <Grid {...defns.profileContent1}>
                                            <AfitdAvatarWithRing
                                                {...defns.profilePic}
                                                src={AliceProfilePic}
                                                photoSize={92}
                                                borderSize={4}
                                                placeholderFontSize={30}
                                                alt={'Profile Picture'}
                                            />
                                        </Grid>
                                        <Grid {...defns.profileContent2}>
                                            <div {...defns.profileContent2Div}>
                                                <div {...defns.profileName}>Alice Rosenbaum</div>
                                                <div {...defns.profileLocation}>Cryptographer - Washington, District of Columbia, United States</div>
                                            </div>

                                            <Grid {...defns.profileQualificationContent}>
                                                <div {...defns.profileQualificationContainer}>
                                                    <AfitdTypography {...defns.profileQualificationIcon}>$ </AfitdTypography>
                                                    <AfitdTypography {...defns.profileQualificationHeading} variant="body2" style={{ marginRight: 9 }}>
                                                        {getSalaryRateText(false, 75000, 80000, 'USD', 'Yearly')}
                                                    </AfitdTypography>
                                                </div>
                                                {/*  2nd content*/}
                                                <div {...defns.profileQualificationContainer}>
                                                    <AccessTimeIcon {...defns.profileQualificationIcon} />
                                                    <AfitdTypography {...defns.profileQualificationHeading} variant="body2" style={{ marginRight: 9 }}>
                                                        Full-time
                                                    </AfitdTypography>
                                                </div>

                                                {/* 3rd content */}
                                                <div {...defns.profileQualificationContainer}>
                                                    <SchoolIcon {...defns.profileQualificationIcon} />
                                                    <AfitdTypography {...defns.profileQualificationHeading} variant="body2" style={{ marginRight: 9 }}>
                                                        Bachelor’s Degree
                                                    </AfitdTypography>
                                                </div>
                                            </Grid>

                                            <div {...defns.profileBtnAndAboutContainer}>
                                                <Grid {...defns.profileBtnContainer}>
                                                    <Grid {...defns.profileBtnContent1}>
                                                        <Grid {...defns.profileTwoButton}>
                                                            <Grid {...defns.profileButtons01}>
                                                                <AfitdButton variant="contained" color="primary" type="submit" value="Submit" {...defns.profileBtn}>
                                                                    <CalendarTodayIcon {...defns.btnLeftIcon} />
                                                                    Request Interview
                                                                </AfitdButton>
                                                            </Grid>
                                                            <Grid {...defns.profileButtons02}>
                                                                <AfitdButton variant="contained" color="secondary" type="submit" value="Submit" {...defns.profileBtn}>
                                                                    <MessageIcon {...defns.btnLeftIcon} />
                                                                    Send Message
                                                                </AfitdButton>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid {...defns.profileBtnContent2}>
                                                        <div {...defns.lastButtonDiv}>
                                                            <AfitdButton variant="contained" color="secondary" type="submit" value="Submit" {...defns.profileLastBtn}>
                                                                <BookmarkBorderIcon {...defns.lastBtnLeftIcon} />
                                                                Save to My Jobs
                                                            </AfitdButton>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <hr />
                                                {/* about section */}
                                                <div {...defns.profileAboutMeSection}>
                                                    <AfitdTypography {...defns.profileDetailHeading}>About Me:</AfitdTypography>
                                                    <p {...defns.profileDetails}>
                                                        I’m an ambitious self-starter committed to utilizing my skills in cyber analytics and advanced mathematics to keep our
                                                        country safe from online threats. As a former virtual assistant, I am highly organized and detail oriented, and am very
                                                        familiar with upholding quality work standards while working remotely.
                                                    </p>
                                                    <p {...defns.profileDetails}>
                                                        I am well versed in several programming languages, have exceptional mathematical skills, and recently completed a short
                                                        contract with a big tech company as an Ethical Hacker. I will be graduating this Fall with a Masters in Mathematics from
                                                        George Mason University. My goal is to combine the knowledge and skills I’ve gained thus far to obtain a Cryptographer or
                                                        Cyber Analyst role in the private sector.
                                                    </p>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Desired Occupation:</AfitdTypography>
                                                    <Grid {...defns.occupationContainer}>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.occupationBtn}>Cryptographer</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.occupationBtn}>Cryptology</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.occupationBtn}>Cybersecurity Analyst</p>
                                                        </Grid>
                                                    </Grid>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Skillset:</AfitdTypography>
                                                    <Grid {...defns.occupationContainer}>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>Java</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>C Sharp (C#)</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>C++</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>Structured Query Language (SQL)</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>HTML</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>COBOL</p>
                                                        </Grid>
                                                    </Grid>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Video Overview:</AfitdTypography>
                                                    <div {...defns.profileDetailContainer}>
                                                        <div {...defns.existingVideoInfoContainer}>
                                                            <div {...defns.existingVideoNameSizeContainer}>
                                                                <AfitdTypography {...defns.existingVideoFilenameText} />
                                                                <AfitdTypography {...defns.existingVideoFileSizeText} />
                                                            </div>
                                                            <div>
                                                                <AfitdTypography {...defns.existingVideoDurationText} />
                                                            </div>
                                                        </div>
                                                        <br />
                                                        <VideoOverviewBlock {...defns.videoOverviewBlock} videoOverviewUrl={ALICE_VIDEO_RESUME_URL} userAvatar={AliceProfilePic} />
                                                    </div>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Resume:</AfitdTypography>
                                                    <div {...defns.profileDetailContainer} style={{ cursor: 'pointer' }}>
                                                        <div {...defns.inline}>
                                                            <AfitdFileTypeIcon {...defns.resumeFileTypeIcon} label={'PDF'} />
                                                            <div {...defns.fileTextContainer}>
                                                                <AfitdTypography {...defns.resumeTitleText} value={'Alice_Resume_1.pdf'} />
                                                                <AfitdTypography {...defns.resumeDateText} value={formatDate(new Date(), 'MM/dd/yyyy')} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Social Media:</AfitdTypography>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <FacebookIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_FACEBOOK}</AfitdTypography>
                                                            <UrlLink
                                                                {...defns.facebookUrl}
                                                                {...defns.socialMediaBlockUrl}
                                                                onClick={() => {
                                                                    socialWindow && socialWindow.close();
                                                                    socialWindow = window.open(
                                                                        AliceFacebook,
                                                                        'afitdhomeprofilesocial',
                                                                        'width=400,height=819,location=0,menubar=0,status=0',
                                                                    );
                                                                }}
                                                                label={'https://www.facebook.com/?alice_rosenbaum'}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <LinkedInIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_LINKEDIN}</AfitdTypography>
                                                            <UrlLink
                                                                {...defns.linkedInUrl}
                                                                {...defns.socialMediaBlockUrl}
                                                                onClick={() => {
                                                                    socialWindow && socialWindow.close();
                                                                    socialWindow = window.open(
                                                                        AliceLinkedIn,
                                                                        'afitdhomeprofilesocial',
                                                                        'width=600,height=519,location=0,menubar=0,status=0',
                                                                    );
                                                                }}
                                                                label={'https://www.linkedin.com/?alice_rosenbaum'}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <InstagramIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_INSTAGRAM}</AfitdTypography>
                                                            <UrlLink
                                                                {...defns.instagramUrl}
                                                                {...defns.socialMediaBlockUrl}
                                                                onClick={() => {
                                                                    socialWindow && socialWindow.close();
                                                                    socialWindow = window.open(
                                                                        AliceInstagram,
                                                                        'afitdhomeprofilesocial',
                                                                        'width=400,height=820,location=0,menubar=0,status=0',
                                                                    );
                                                                }}
                                                                label={'https://www.instagram.com/?allaboutalice'}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <TwitterIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_TWITTER}</AfitdTypography>
                                                            <UrlLink {...defns.twitterUrl} {...defns.socialMediaBlockUrl} />
                                                        </div>
                                                    </div>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <YouTubeIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_YOUTUBE}</AfitdTypography>
                                                            <UrlLink {...defns.youTubeUrl} {...defns.socialMediaBlockUrl} />
                                                        </div>
                                                    </div>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <WebsiteIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_WEBSITE}</AfitdTypography>
                                                            <UrlLink {...defns.websiteUrl} {...defns.socialMediaBlockUrlPlaceHolder} />
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid {...defns.arrowForward}>
                                    <img {...defns.arrowForwardImg} src={arrowForward} alt="" onClick={handleClickPreviousProfileButton.bind(null, 2)} />
                                </Grid>
                            </Grid>
                        </Modal>
                        {/* ============================================================== */}
                        {/* == Profile 2                                                  */}
                        {/* ============================================================== */}
                        <Modal
                            open={currentProfileIdx === 2}
                            onClose={handleCloseProfile}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            {...defns.seeProfileModalStyle}
                        >
                            <Grid {...defns.modalContainer}>
                                <Grid {...defns.arrowBack}>
                                    <img {...defns.arrowBackImg} src={arrowBack} alt="" onClick={handleClickPreviousProfileButton.bind(null, 1)} />
                                </Grid>

                                <Grid {...defns.profileModalContent}>
                                    <div {...defns.closeIconContainerProfile}>
                                        <CloseIcon {...defns.closeIconContent} onClick={handleCloseProfile} />
                                    </div>

                                    <Grid {...defns.profileContainer}>
                                        <Grid {...defns.profileContent1}>
                                            <AfitdAvatarWithRing
                                                {...defns.profilePic}
                                                src={SilasProfilePic}
                                                photoSize={92}
                                                borderSize={4}
                                                placeholderFontSize={30}
                                                alt={'Profile Picture'}
                                            />
                                        </Grid>
                                        <Grid {...defns.profileContent2}>
                                            <div {...defns.profileContent2Div}>
                                                <div {...defns.profileName}>Silas Adams</div>
                                                <div {...defns.profileLocation}>Architect - New York, New York, United States</div>
                                            </div>

                                            <Grid {...defns.profileQualificationContent}>
                                                <div {...defns.profileQualificationContainer}>
                                                    <AfitdTypography {...defns.profileQualificationIcon}>$ </AfitdTypography>
                                                    <AfitdTypography {...defns.profileQualificationHeading} variant="body2" style={{ marginRight: 9 }}>
                                                        {getSalaryRateText(false, 80000, 90000, 'USD', 'Yearly')}
                                                    </AfitdTypography>
                                                </div>
                                                {/*  2nd content*/}
                                                <div {...defns.profileQualificationContainer}>
                                                    <AccessTimeIcon {...defns.profileQualificationIcon} />
                                                    <AfitdTypography {...defns.profileQualificationHeading} variant="body2" style={{ marginRight: 9 }}>
                                                        Full-time
                                                    </AfitdTypography>
                                                </div>

                                                {/* 3rd content */}
                                                <div {...defns.profileQualificationContainer}>
                                                    <SchoolIcon {...defns.profileQualificationIcon} />
                                                    <AfitdTypography {...defns.profileQualificationHeading} variant="body2" style={{ marginRight: 9 }}>
                                                        Bachelor’s Degree
                                                    </AfitdTypography>
                                                </div>
                                            </Grid>

                                            <div {...defns.profileBtnAndAboutContainer}>
                                                <Grid {...defns.profileBtnContainer}>
                                                    <Grid {...defns.profileBtnContent1}>
                                                        <Grid {...defns.profileTwoButton}>
                                                            <Grid {...defns.profileButtons01}>
                                                                <AfitdButton variant="contained" color="primary" type="submit" value="Submit" {...defns.profileBtn}>
                                                                    <CalendarTodayIcon {...defns.btnLeftIcon} />
                                                                    Request Interview
                                                                </AfitdButton>
                                                            </Grid>
                                                            <Grid {...defns.profileButtons02}>
                                                                <AfitdButton variant="contained" color="secondary" type="submit" value="Submit" {...defns.profileBtn}>
                                                                    <MessageIcon {...defns.btnLeftIcon} />
                                                                    Send Message
                                                                </AfitdButton>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid {...defns.profileBtnContent2}>
                                                        <div {...defns.lastButtonDiv}>
                                                            <AfitdButton variant="contained" color="secondary" type="submit" value="Submit" {...defns.profileLastBtn}>
                                                                <BookmarkBorderIcon {...defns.lastBtnLeftIcon} />
                                                                Save to My Jobs
                                                            </AfitdButton>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <hr />
                                                {/* about section */}
                                                <div {...defns.profileAboutMeSection}>
                                                    <AfitdTypography {...defns.profileDetailHeading}>About Me:</AfitdTypography>
                                                    <p {...defns.profileDetails}>
                                                        I’m a second generation architect in New York City looking to obtain a position with an established architecture and design
                                                        firm. I believe that communities, and society as a whole, can be strengthened through architecture, which is why I
                                                        specialize in restoration design. My ultimate goal is to build up underserved areas of New York to bring them back to life
                                                        and provide quality homes and business space that enable residents to thrive.
                                                    </p>
                                                    <p {...defns.profileDetails}>
                                                        I’m a highly motivated individual with natural leadership capabilities. I approach solving problems analytically and
                                                        creatively. I’ve found success in both independent and team environments, but like the communities we build, I find that the
                                                        best progress happens when working together.
                                                    </p>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Desired Occupation:</AfitdTypography>
                                                    <Grid {...defns.occupationContainer}>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.occupationBtn}>Architecture</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.occupationBtn}>Architect Designer</p>
                                                        </Grid>
                                                    </Grid>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Skillset:</AfitdTypography>
                                                    <Grid {...defns.occupationContainer}>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>SketchUp</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>ArchiCAD</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>Adobe CC</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>Communication</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>Advanced Math</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>Analytical Problem Resolution</p>
                                                        </Grid>
                                                    </Grid>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Video Overview:</AfitdTypography>
                                                    <div {...defns.profileDetailContainer}>
                                                        <div {...defns.existingVideoInfoContainer}>
                                                            <div {...defns.existingVideoNameSizeContainer}>
                                                                <AfitdTypography {...defns.existingVideoFilenameText} />
                                                                <AfitdTypography {...defns.existingVideoFileSizeText} />
                                                            </div>
                                                            <div>
                                                                <AfitdTypography {...defns.existingVideoDurationText} />
                                                            </div>
                                                        </div>
                                                        <VideoOverviewBlock {...defns.videoOverviewBlock} videoOverviewUrl={SILAS_VIDEO_RESUME_URL} userAvatar={SilasProfilePic} />
                                                    </div>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Resume:</AfitdTypography>
                                                    <div {...defns.profileDetailContainer} style={{ cursor: 'pointer' }}>
                                                        <div {...defns.inline}>
                                                            <AfitdFileTypeIcon {...defns.resumeFileTypeIcon} label={'PDF'} />
                                                            <div {...defns.fileTextContainer}>
                                                                <AfitdTypography {...defns.resumeTitleText} value={'Silas_Adams_Architect_Resume.pdf'} />
                                                                <AfitdTypography {...defns.resumeDateText} value={formatDate(subDays(new Date(), 2), 'MM/dd/yyyy')} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Social Media:</AfitdTypography>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <FacebookIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_FACEBOOK}</AfitdTypography>
                                                            <UrlLink
                                                                {...defns.facebookUrl}
                                                                {...defns.socialMediaBlockUrl}
                                                                onClick={() => {
                                                                    socialWindow && socialWindow.close();
                                                                    socialWindow = window.open(
                                                                        SilasFacebook,
                                                                        'afitdhomeprofilesocial',
                                                                        'width=400,height=819,location=0,menubar=0,status=0',
                                                                    );
                                                                }}
                                                                label={'https://www.facebook.com/?silas_adams'}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <LinkedInIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_LINKEDIN}</AfitdTypography>
                                                            <UrlLink
                                                                {...defns.linkedInUrl}
                                                                {...defns.socialMediaBlockUrl}
                                                                onClick={() => {
                                                                    socialWindow && socialWindow.close();
                                                                    socialWindow = window.open(
                                                                        SilasLinkedIn,
                                                                        'afitdhomeprofilesocial',
                                                                        'width=600,height=519,location=0,menubar=0,status=0',
                                                                    );
                                                                }}
                                                                label={'https://www.linkedin.com/?silas_adams'}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <InstagramIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_INSTAGRAM}</AfitdTypography>
                                                            <UrlLink
                                                                {...defns.instagramUrl}
                                                                {...defns.socialMediaBlockUrl}
                                                                onClick={() => {
                                                                    socialWindow && socialWindow.close();
                                                                    socialWindow = window.open(
                                                                        SilasInstagram,
                                                                        'afitdhomeprofilesocial',
                                                                        'width=400,height=820,location=0,menubar=0,status=0',
                                                                    );
                                                                }}
                                                                label={'https://www.instagram.com/?silasbuilds_'}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <TwitterIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_TWITTER}</AfitdTypography>
                                                            <UrlLink {...defns.twitterUrl} {...defns.socialMediaBlockUrl} />
                                                        </div>
                                                    </div>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <YouTubeIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_YOUTUBE}</AfitdTypography>
                                                            <UrlLink {...defns.youTubeUrl} {...defns.socialMediaBlockUrl} />
                                                        </div>
                                                    </div>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <WebsiteIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_WEBSITE}</AfitdTypography>
                                                            <UrlLink {...defns.websiteUrl} {...defns.socialMediaBlockUrlPlaceHolder} />
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid {...defns.arrowForward}>
                                    <img {...defns.arrowForwardImg} src={arrowForward} alt="" onClick={handleClickPreviousProfileButton.bind(null, 3)} />
                                </Grid>
                            </Grid>
                        </Modal>
                        {/* ============================================================== */}
                        {/* == Profile 3                                                  */}
                        {/* ============================================================== */}
                        <Modal
                            open={currentProfileIdx === 3}
                            onClose={handleCloseProfile}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            {...defns.seeProfileModalStyle}
                        >
                            <Grid {...defns.modalContainer}>
                                <Grid {...defns.arrowBack}>
                                    <img {...defns.arrowBackImg} src={arrowBack} alt="" onClick={handleClickPreviousProfileButton.bind(null, 2)} />
                                </Grid>

                                <Grid {...defns.profileModalContent}>
                                    <div {...defns.closeIconContainerProfile}>
                                        <CloseIcon {...defns.closeIconContent} onClick={handleCloseProfile} />
                                    </div>

                                    <Grid {...defns.profileContainer}>
                                        <Grid {...defns.profileContent1}>
                                            <AfitdAvatarWithRing
                                                {...defns.profilePic}
                                                src={MicahProfilePic}
                                                photoSize={92}
                                                borderSize={4}
                                                placeholderFontSize={30}
                                                alt={'Profile Picture'}
                                            />
                                        </Grid>
                                        <Grid {...defns.profileContent2}>
                                            <div {...defns.profileContent2Div}>
                                                <div {...defns.profileName}>Micah Roberts</div>
                                                <div {...defns.profileLocation}>Wind Turbine Tech Internship - Waco, Texas, United States</div>
                                            </div>

                                            <Grid {...defns.profileQualificationContent}>
                                                <div {...defns.profileQualificationContainer}>
                                                    <AfitdTypography {...defns.profileQualificationIcon}>$ </AfitdTypography>
                                                    <AfitdTypography {...defns.profileQualificationHeading} variant="body2" style={{ marginRight: 9 }}>
                                                        {getSalaryRateText(true, 25000, 25000, 'USD', 'Yearly')}
                                                    </AfitdTypography>
                                                </div>
                                                {/*  2nd content*/}
                                                <div {...defns.profileQualificationContainer}>
                                                    <AccessTimeIcon {...defns.profileQualificationIcon} />
                                                    <AfitdTypography {...defns.profileQualificationHeading} variant="body2" style={{ marginRight: 9 }}>
                                                        Part-time, Internship
                                                    </AfitdTypography>
                                                </div>

                                                {/* 3rd content */}
                                                <div {...defns.profileQualificationContainer}>
                                                    <SchoolIcon {...defns.profileQualificationIcon} />
                                                    <AfitdTypography {...defns.profileQualificationHeading} variant="body2" style={{ marginRight: 9 }}>
                                                        Some College
                                                    </AfitdTypography>
                                                </div>
                                            </Grid>

                                            <div {...defns.profileBtnAndAboutContainer}>
                                                <Grid {...defns.profileBtnContainer}>
                                                    <Grid {...defns.profileBtnContent1}>
                                                        <Grid {...defns.profileTwoButton}>
                                                            <Grid {...defns.profileButtons01}>
                                                                <AfitdButton variant="contained" color="primary" type="submit" value="Submit" {...defns.profileBtn}>
                                                                    <CalendarTodayIcon {...defns.btnLeftIcon} />
                                                                    Request Interview
                                                                </AfitdButton>
                                                            </Grid>
                                                            <Grid {...defns.profileButtons02}>
                                                                <AfitdButton variant="contained" color="secondary" type="submit" value="Submit" {...defns.profileBtn}>
                                                                    <MessageIcon {...defns.btnLeftIcon} />
                                                                    Send Message
                                                                </AfitdButton>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid {...defns.profileBtnContent2}>
                                                        <div {...defns.lastButtonDiv}>
                                                            <AfitdButton variant="contained" color="secondary" type="submit" value="Submit" {...defns.profileLastBtn}>
                                                                <BookmarkBorderIcon {...defns.lastBtnLeftIcon} />
                                                                Save to My Jobs
                                                            </AfitdButton>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <hr />
                                                {/* about section */}
                                                <div {...defns.profileAboutMeSection}>
                                                    <AfitdTypography {...defns.profileDetailHeading}>About Me:</AfitdTypography>
                                                    <p {...defns.profileDetails}>
                                                        I’m currently a student at Texas State Technical College pursuing their Wind Turbine Technician program. Growing up on a
                                                        farm, I have a background in mechanics and excel at thinking critically to complete troubleshooting and repairs for major
                                                        machinery. I hope to combine that knowledge with what I’m learning at TSTC to obtain an internship with a reputable
                                                        environmental company in order to gain real wind technology experience.
                                                    </p>
                                                    <p {...defns.profileDetails}>
                                                        In addition to mechanical, diagnostic, and repair skills, I’m also adept at reading schematics, completing timely
                                                        records/documentation, and have entry-level experience performing electrical repairs. I’m an innovative thinker and problem
                                                        solver who is highly motivated to help our country transition to sustainable energy resources.
                                                    </p>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Desired Occupation:</AfitdTypography>
                                                    <Grid {...defns.occupationContainer}>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.occupationBtn}>Wind Technician</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.occupationBtn}>Student Intern</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.occupationBtn}>Wind Energy Engineer</p>
                                                        </Grid>
                                                    </Grid>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Skillset:</AfitdTypography>
                                                    <Grid {...defns.occupationContainer}>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>Construction Workflow</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>Workplace Safety</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>Mechanical Technician</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>Equipment Layout</p>
                                                        </Grid>
                                                    </Grid>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Video Overview:</AfitdTypography>
                                                    <div {...defns.profileDetailContainer}>
                                                        <div {...defns.existingVideoInfoContainer}>
                                                            <div {...defns.existingVideoNameSizeContainer}>
                                                                <AfitdTypography {...defns.existingVideoFilenameText} />
                                                                <AfitdTypography {...defns.existingVideoFileSizeText} />
                                                            </div>
                                                            <div>
                                                                <AfitdTypography {...defns.existingVideoDurationText} />
                                                            </div>
                                                        </div>
                                                        <VideoOverviewBlock {...defns.videoOverviewBlock} videoOverviewUrl={MICAH_VIDEO_RESUME_URL} userAvatar={MicahProfilePic} />
                                                    </div>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Resume:</AfitdTypography>
                                                    <div {...defns.profileDetailContainer} style={{ cursor: 'pointer' }}>
                                                        <div {...defns.inline}>
                                                            <AfitdFileTypeIcon {...defns.resumeFileTypeIcon} label={'PDF'} />
                                                            <div {...defns.fileTextContainer}>
                                                                <AfitdTypography {...defns.resumeTitleText} value={`${formatDate(subDays(new Date(), 7), 'yyyy_MM')}_Resume.pdf`} />
                                                                <AfitdTypography {...defns.resumeDateText} value={formatDate(subDays(new Date(), 7), 'MM/dd/yyyy')} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Social Media:</AfitdTypography>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <FacebookIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_FACEBOOK}</AfitdTypography>
                                                            <UrlLink
                                                                {...defns.facebookUrl}
                                                                {...defns.socialMediaBlockUrl}
                                                                onClick={() => {
                                                                    socialWindow && socialWindow.close();
                                                                    socialWindow = window.open(
                                                                        MicahFacebook,
                                                                        'afitdhomeprofilesocial',
                                                                        'width=400,height=819,location=0,menubar=0,status=0',
                                                                    );
                                                                }}
                                                                label={'https://www.facebook.com/?micah_roberts'}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <LinkedInIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_LINKEDIN}</AfitdTypography>
                                                            <UrlLink
                                                                {...defns.linkedInUrl}
                                                                {...defns.socialMediaBlockUrl}
                                                                onClick={() => {
                                                                    socialWindow && socialWindow.close();
                                                                    socialWindow = window.open(
                                                                        MicahLinkedIn,
                                                                        'afitdhomeprofilesocial',
                                                                        'width=600,height=519,location=0,menubar=0,status=0',
                                                                    );
                                                                }}
                                                                label={'https://www.linkedin.com/?micah_roberts'}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <InstagramIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_INSTAGRAM}</AfitdTypography>
                                                            <UrlLink
                                                                {...defns.instagramUrl}
                                                                {...defns.socialMediaBlockUrl}
                                                                onClick={() => {
                                                                    socialWindow && socialWindow.close();
                                                                    socialWindow = window.open(
                                                                        MicahInstagram,
                                                                        'afitdhomeprofilesocial',
                                                                        'width=400,height=820,location=0,menubar=0,status=0',
                                                                    );
                                                                }}
                                                                label={'https://www.instagram.com/?enviromike'}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <TwitterIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_TWITTER}</AfitdTypography>
                                                            <UrlLink {...defns.twitterUrl} {...defns.socialMediaBlockUrl} />
                                                        </div>
                                                    </div>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <YouTubeIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_YOUTUBE}</AfitdTypography>
                                                            <UrlLink {...defns.youTubeUrl} {...defns.socialMediaBlockUrl} />
                                                        </div>
                                                    </div>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <WebsiteIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_WEBSITE}</AfitdTypography>
                                                            <UrlLink {...defns.websiteUrl} {...defns.socialMediaBlockUrlPlaceHolder} />
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid {...defns.arrowForward}>
                                    <img {...defns.arrowForwardImg} src={arrowForward} alt="" onClick={handleClickPreviousProfileButton.bind(null, 4)} />
                                </Grid>
                            </Grid>
                        </Modal>
                        {/* ============================================================== */}
                        {/* == Profile 4                                                  */}
                        {/* ============================================================== */}
                        <Modal
                            open={currentProfileIdx === 4}
                            onClose={handleCloseProfile}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            {...defns.seeProfileModalStyle}
                        >
                            <Grid {...defns.modalContainer}>
                                <Grid {...defns.arrowBack}>
                                    <img {...defns.arrowBackImg} src={arrowBack} alt="" onClick={handleClickPreviousProfileButton.bind(null, 3)} />
                                </Grid>

                                <Grid {...defns.profileModalContent}>
                                    <div {...defns.closeIconContainerProfile}>
                                        <CloseIcon {...defns.closeIconContent} onClick={handleCloseProfile} />
                                    </div>

                                    <Grid {...defns.profileContainer}>
                                        <Grid {...defns.profileContent1}>
                                            <AfitdAvatarWithRing
                                                {...defns.profilePic}
                                                src={JadaProfilePic}
                                                photoSize={92}
                                                borderSize={4}
                                                placeholderFontSize={30}
                                                alt={'Profile Picture'}
                                            />
                                        </Grid>
                                        <Grid {...defns.profileContent2}>
                                            <div {...defns.profileContent2Div}>
                                                <div {...defns.profileName}>Jada Flores</div>
                                                <div {...defns.profileLocation}>Makeup Artist - Los Angeles, California, United States</div>
                                            </div>

                                            <Grid {...defns.profileQualificationContent}>
                                                <div {...defns.profileQualificationContainer}>
                                                    <AfitdTypography {...defns.profileQualificationIcon}>$ </AfitdTypography>
                                                    <AfitdTypography {...defns.profileQualificationHeading} variant="body2" style={{ marginRight: 9 }}>
                                                        {getSalaryRateText(false, 50000, 60000, 'USD', 'Yearly')}
                                                    </AfitdTypography>
                                                </div>
                                                {/*  2nd content*/}
                                                <div {...defns.profileQualificationContainer}>
                                                    <AccessTimeIcon {...defns.profileQualificationIcon} />
                                                    <AfitdTypography {...defns.profileQualificationHeading} variant="body2" style={{ marginRight: 9 }}>
                                                        Gig Work
                                                    </AfitdTypography>
                                                </div>

                                                {/* 3rd content */}
                                                <div {...defns.profileQualificationContainer}>
                                                    <SchoolIcon {...defns.profileQualificationIcon} />
                                                    <AfitdTypography {...defns.profileQualificationHeading} variant="body2" style={{ marginRight: 9 }}>
                                                        Hollywood Makeup School
                                                    </AfitdTypography>
                                                </div>
                                            </Grid>

                                            <div {...defns.profileBtnAndAboutContainer}>
                                                <Grid {...defns.profileBtnContainer}>
                                                    <Grid {...defns.profileBtnContent1}>
                                                        <Grid {...defns.profileTwoButton}>
                                                            <Grid {...defns.profileButtons01}>
                                                                <AfitdButton variant="contained" color="primary" type="submit" value="Submit" {...defns.profileBtn}>
                                                                    <CalendarTodayIcon {...defns.btnLeftIcon} />
                                                                    Request Interview
                                                                </AfitdButton>
                                                            </Grid>
                                                            <Grid {...defns.profileButtons02}>
                                                                <AfitdButton variant="contained" color="secondary" type="submit" value="Submit" {...defns.profileBtn}>
                                                                    <MessageIcon {...defns.btnLeftIcon} />
                                                                    Send Message
                                                                </AfitdButton>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid {...defns.profileBtnContent2}>
                                                        <div {...defns.lastButtonDiv}>
                                                            <AfitdButton variant="contained" color="secondary" type="submit" value="Submit" {...defns.profileLastBtn}>
                                                                <BookmarkBorderIcon {...defns.lastBtnLeftIcon} />
                                                                Save to My Jobs
                                                            </AfitdButton>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <hr />
                                                {/* about section */}
                                                <div {...defns.profileAboutMeSection}>
                                                    <AfitdTypography {...defns.profileDetailHeading}>About Me:</AfitdTypography>
                                                    <p {...defns.profileDetails}>
                                                        I am a licensed professional makeup artist looking for freelance or contract opportunities in LA. My background includes
                                                        theatrical makeup, entertainment/personality makeup, and special effects makeup. I’ve had wonderful opportunities to work
                                                        with local television networks, and have also been a personal stylist/artist for several VIP clients. My passion is special
                                                        effects makeup, but I enjoy any chance to be creative with my brushes.
                                                    </p>
                                                    <p {...defns.profileDetails}>
                                                        I take pride in continuing education and make an effort to complete training and classes annually to ensure that I’m up to
                                                        date on the latest industry trends and techniques. I take client safety and anonymity very seriously and whether the
                                                        opportunity is on location or in my studio, I will ensure a professional environment.
                                                    </p>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Desired Occupation:</AfitdTypography>
                                                    <Grid {...defns.occupationContainer}>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.occupationBtn}>Makeup Artist</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.occupationBtn}>Cosmetologist</p>
                                                        </Grid>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.occupationBtn}>Cinematic Makeup Artist</p>
                                                        </Grid>
                                                    </Grid>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Skillset:</AfitdTypography>
                                                    <Grid {...defns.occupationContainer}>
                                                        <Grid {...defns.occupationItem}>
                                                            <p {...defns.skillBtn}>Special Effects Makeup</p>
                                                        </Grid>
                                                    </Grid>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Video Overview:</AfitdTypography>
                                                    <div {...defns.profileDetailContainer}>
                                                        <div {...defns.existingVideoInfoContainer}>
                                                            <div {...defns.existingVideoNameSizeContainer}>
                                                                <AfitdTypography {...defns.existingVideoFilenameText} />
                                                                <AfitdTypography {...defns.existingVideoFileSizeText} />
                                                            </div>
                                                            <div>
                                                                <AfitdTypography {...defns.existingVideoDurationText} />
                                                            </div>
                                                        </div>
                                                        <VideoOverviewBlock {...defns.videoOverviewBlock} videoOverviewUrl={JADA_VIDEO_RESUME_URL} userAvatar={JadaProfilePic} />
                                                    </div>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Resume:</AfitdTypography>
                                                    <div {...defns.profileDetailContainer} style={{ cursor: 'pointer' }}>
                                                        <div {...defns.inline}>
                                                            <AfitdFileTypeIcon {...defns.resumeFileTypeIcon} label={'DOC'} />
                                                            <div {...defns.fileTextContainer}>
                                                                <AfitdTypography
                                                                    {...defns.resumeTitleText}
                                                                    value={`Jada_Resume_${formatDate(subDays(new Date(), 5), 'yyyy')}.docx`}
                                                                />
                                                                <AfitdTypography {...defns.resumeDateText} value={formatDate(subDays(new Date(), 5), 'MM/dd/yyyy')} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <AfitdTypography {...defns.profileDetailHeading}>Social Media:</AfitdTypography>
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <FacebookIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_FACEBOOK}</AfitdTypography>
                                                            <UrlLink
                                                                {...defns.facebookUrl}
                                                                {...defns.socialMediaBlockUrl}
                                                                onClick={() => {
                                                                    socialWindow && socialWindow.close();
                                                                    socialWindow = window.open(
                                                                        JadaFacebook,
                                                                        'afitdhomeprofilesocial',
                                                                        'width=400,height=819,location=0,menubar=0,status=0',
                                                                    );
                                                                }}
                                                                label={'https://www.facebook.com/?jada_flores'}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <LinkedInIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_LINKEDIN}</AfitdTypography>
                                                            <UrlLink {...defns.linkedInUrl} {...defns.socialMediaBlockUrl} />
                                                        </div>
                                                    </div> */}
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <InstagramIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_INSTAGRAM}</AfitdTypography>
                                                            <UrlLink
                                                                {...defns.instagramUrl}
                                                                {...defns.socialMediaBlockUrl}
                                                                onClick={() => {
                                                                    socialWindow && socialWindow.close();
                                                                    socialWindow = window.open(
                                                                        JadaInstagram,
                                                                        'afitdhomeprofilesocial',
                                                                        'width=400,height=820,location=0,menubar=0,status=0',
                                                                    );
                                                                }}
                                                                label={'https://www.instagram.com/?jadabeauty_la'}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <TwitterIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_TWITTER}</AfitdTypography>
                                                            <UrlLink {...defns.twitterUrl} {...defns.socialMediaBlockUrl} />
                                                        </div>
                                                    </div> */}
                                                    <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <YouTubeIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_YOUTUBE}</AfitdTypography>
                                                            <UrlLink
                                                                {...defns.youTubeUrl}
                                                                {...defns.socialMediaBlockUrl}
                                                                onClick={() => {
                                                                    socialWindow && socialWindow.close();
                                                                    socialWindow = window.open(
                                                                        JadaYouTube,
                                                                        'afitdhomeprofilesocial',
                                                                        'width=500,height=725,location=0,menubar=0,status=0',
                                                                    );
                                                                }}
                                                                label={'https://www.youtube.com/?jadabeauty_la'}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* <div {...defns.socialMediaBlock}>
                                                        <div {...defns.iconsContainer}>
                                                            <WebsiteIcon {...defns.socialIcons} />
                                                        </div>
                                                        <div>
                                                            <AfitdTypography {...defns.socialMediaBlockTitle}>{PROFILE_SOCIAL_MEDIA_WEBSITE}</AfitdTypography>
                                                            <UrlLink {...defns.websiteUrl} {...defns.socialMediaBlockUrlPlaceHolder} />
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid {...defns.arrowForward}>
                                    <img {...defns.arrowForwardImg} src={arrowForward} alt="" onClick={handleClickPreviousProfileButton.bind(null, 1)} />
                                </Grid>
                            </Grid>
                        </Modal>
                    </div>

                    {/* profile modal end */}

                    <h1 {...defns.heading}>Showcase Your Talent, Skills, and Story</h1>
                    <p {...defns.secondaryParagraph}>Click on the job seeker profiles below and see what makes them stand out</p>
                    <AfitdTypography {...defns.exampleProfilesDisclaimerText}>(Example profiles are for illustrative purposes only)</AfitdTypography>
                    <Grid {...defns.homeContainer}>
                        <Grid {...defns.stageSection}>
                            <div {...defns.imageContainer}>
                                <img style={{ width: '85%', maxWidth: 220, cursor: 'pointer' }} src={stageImg1} alt="" onClick={handleOpenProfile.bind(null, 1)} />
                            </div>
                            <p {...defns.stageName}>Alice Rosenbaum</p>
                            <p {...defns.stageDeg}>Cryptographer</p>
                            <div {...defns.stageButtonContainer}>
                                <button {...defns.stageButton} onClick={handleOpenProfile.bind(null, 1)}>
                                    SEE PROFILE
                                </button>
                            </div>
                        </Grid>
                        <Grid {...defns.stageSection}>
                            <div {...defns.imageContainer}>
                                <img style={{ width: '85%', maxWidth: 220, cursor: 'pointer' }} src={stageImg2} alt="" onClick={handleOpenProfile.bind(null, 2)} />
                            </div>
                            <p {...defns.stageName}>Silas Adams</p>
                            <p {...defns.stageDeg}>Architect</p>
                            <div {...defns.stageButtonContainer}>
                                <button {...defns.stageButton} onClick={handleOpenProfile.bind(null, 2)}>
                                    SEE PROFILE
                                </button>
                            </div>
                        </Grid>
                        <Grid {...defns.stageSection}>
                            <div {...defns.imageContainer}>
                                <img style={{ width: '85%', maxWidth: 220, cursor: 'pointer' }} src={stageImg3} alt="" onClick={handleOpenProfile.bind(null, 3)} />
                            </div>
                            <p {...defns.stageName}>Micah Roberts</p>
                            <p {...defns.stageDeg}>Wind Turbine Tech</p>
                            <div {...defns.stageButtonContainer}>
                                <button {...defns.stageButton} onClick={handleOpenProfile.bind(null, 3)}>
                                    SEE PROFILE
                                </button>
                            </div>
                        </Grid>
                        <Grid {...defns.stageSection}>
                            <div {...defns.imageContainer}>
                                <img style={{ width: '85%', maxWidth: 220, cursor: 'pointer' }} src={stageImg4} alt="" onClick={handleOpenProfile.bind(null, 4)} />
                            </div>
                            <p {...defns.stageName}>Jada Flores</p>
                            <p {...defns.stageDeg}>Makeup Artist</p>
                            <div {...defns.stageButtonContainer}>
                                <button {...defns.stageButton} onClick={handleOpenProfile.bind(null, 4)}>
                                    SEE PROFILE
                                </button>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <div {...defns.blackContainer}>
                    <h1 {...defns.whiteHeading}>
                        We never box you in. <br />
                        Neither do jobs listed here.
                    </h1>
                    <Grid {...defns.homeContainer}>
                        <Grid {...defns.homeSection}>
                            <div {...defns.imageContainer}>
                                <img {...defns.image} src={image2} alt="" />
                            </div>
                        </Grid>
                        <Grid {...defns.homeSection}>
                            {/* <p {...defns.whiteParagraphHead}></p> */}
                            <p {...defns.whiteParagraph}>
                                <span {...defns.whiteParagraphHead}>Because the truth is, you’re way more than a resume.</span> <br />
                                That’s why <span style={{ fontWeight: 'bold' }}> A Foot in the Door</span> helps you score life-changing interviews with employers who focus on your
                                potential, not just your years of experience. Show hiring managers who you are and what you offer through short video reels. Just like all of your
                                favorite apps on the internet. You see, we know that great companies don’t just want resumes. They keep an eye out for talent. Now show ‘em what
                                you’ve got!
                            </p>
                            <div {...defns.circleImageBottomPadding}></div>
                        </Grid>
                    </Grid>
                    <Grid {...defns.blackContainerCircle}>
                        <img src={circle} alt="" {...defns.blackContainerCircleImg} />
                    </Grid>
                </div>
                <div {...defns.cardContainer}>
                    <div {...defns.card}>
                        <div {...defns.cardTop}>
                            <div {...defns.cardName}>
                                <div {...defns.cardImg}>
                                    <img src={cardImg1} alt="" />
                                </div>
                                <div {...defns.cardText}>
                                    <p {...defns.cardTextPrimary}>Wade Chen</p>
                                    <p {...defns.cardTextSecondary}>Technical Writer</p>
                                </div>
                            </div>
                            <div {...defns.cardComma}>
                                <img src={cardComma} alt="" />
                            </div>
                        </div>
                        <p {...defns.resumeCardParagraph}>
                            "I’ve been on every major job search platform, and when I found A Foot in the Door, it was like a breath of fresh air. No other platform makes it this
                            easy to connect with employers. For once I feel like my profile is an accurate portrayal of me and my experience."
                        </p>
                    </div>
                    <div {...defns.card}>
                        <div {...defns.cardTop}>
                            <div {...defns.cardName}>
                                <div {...defns.cardImg}>
                                    <img src={cardImg2} alt="" />
                                </div>
                                <div {...defns.cardText}>
                                    <p {...defns.cardTextPrimary}>Charlotte Burke</p>
                                    <p {...defns.cardTextSecondary}>Marketing Consultant</p>
                                </div>
                            </div>
                            <div {...defns.cardComma}>
                                <img src={cardComma} alt="" />
                            </div>
                        </div>
                        <p {...defns.resumeCardParagraph}>
                            "When I came across A Foot in the Door, I was immediately drawn in by their modern approach to what can be a cumbersome ordeal. Their process made it to
                            where I was more than just a name on another resume. I actually enjoyed making my 60 second video and now I really feel like I have the opportunity to
                            show potential employers who I am."
                        </p>
                    </div>
                </div>

                <h1 {...defns.heading}>Create a free profile now</h1>
                <p {...defns.secondaryParagraph}>
                    Help hiring managers really get to know you. Create a 60 second video sharing your story. <br /> Have no fear, it’s just practice until you make your profile
                    public.
                </p>
                <div {...defns.buttonContainer}>
                    <div>
                        <button {...defns.button} type="button" onClick={handleOpenLoginModal}>
                            Get Started
                        </button>
                    </div>
                </div>

                {mdMatches ? (
                    <Grid {...defns.homeContainer}>
                        {/*--------------------------------------------------------------------------- */}
                        {/*-- Uncomment when app is available in Apple App Store and Google Play Store */}
                        {/*--------------------------------------------------------------------------- */}
                        <Grid {...defns.homeSection2}>
                            <div {...defns.imageContainer} style={{ maxWidth: 360, marginLeft: 'auto', marginRight: 'auto' }}>
                                <img {...defns.img} src={image1} alt="" />
                            </div>
                        </Grid>
                        <Grid {...defns.homeSection2}>
                            <h2 {...defns.secondaryHeading2} style={{ textAlign: 'center', marginLeft: 'auto', marginRight: 'auto', maxWidth: 'auto' }}>
                                Search, Find and Apply for jobs directly on your mobile device
                            </h2>
                            <p {...defns.paragraph} style={{ textAlign: 'center', marginLeft: 'auto', marginRight: 'auto', marginBottom: 35 }}>
                                Apply for jobs, manage your profile and even chat <br />
                                with employers while on-the-go.
                            </p>
                            <Grid {...defns.footerStoreButtonContainer}>
                                <Grid {...defns.appStoreButton}>
                                    <img {...defns.appStoreImage} src={appStoreImage} alt="" />
                                </Grid>
                                <Grid {...defns.googlePlayStoreButton}>
                                    <img {...defns.googlePlayStoreImage} src={googlePlayStoreImage} alt="" />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid {...defns.homeContainer}>
                        {/*--------------------------------------------------------------------------- */}
                        {/*-- Uncomment when app is available in Apple App Store and Google Play Store */}
                        {/*--------------------------------------------------------------------------- */}
                        <Grid {...defns.homeSection2}>
                            <h2 {...defns.secondaryHeading} style={{ marginTop: 80 }}>
                                Search, Find and Apply for jobs directly on your mobile device
                            </h2>
                            <p {...defns.paragraph}>
                                Apply for jobs, manage your profile and even chat <br />
                                with employers while on-the-go.
                            </p>
                            <Grid {...defns.footerStoreButtonContainer}>
                                <Grid {...defns.appStoreButton}>
                                    <img {...defns.appStoreImage} src={appStoreImage} alt="" />
                                </Grid>
                                <Grid {...defns.googlePlayStoreButton}>
                                    <img {...defns.googlePlayStoreImage} src={googlePlayStoreImage} alt="" />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid {...defns.homeSection2}>
                            <div {...defns.imageContainer} style={{ maxWidth: 500, marginLeft: 'auto' }}>
                                <img {...defns.img} src={image1} alt="" />
                            </div>
                        </Grid>
                    </Grid>
                )}
            </div>
            {/* ================== Login/Register Modal Section ================== */}
            <LoginDialog {...defns.loginDialog} />
            <Footer />
        </div>
    );
};

export default Landing;
